import React from "react";
import useWindowDimensions from "../../functions/windows";
import { IPaymentTracking } from "../../interfaces/paymentTracking";
import { IPets } from "../../interfaces/pets";
import { useBookingsList } from "../../store/Booking";
import { useError } from "../../store/ErrorModal";

export default function useDashboardPage() {
  const { bookings, fetchBookings, setBookings, isLoadingBookings } =
    useBookingsList();
  const { width } = useWindowDimensions();
  const { onError } = useError();

  const [dataCard, setDataCard] = React.useState<IPaymentTracking>(bookings[0]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  const getPet = (pets: IPets[], pid: string) =>
    pets.find((pet) => pet.pid === pid);

  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      await fetchBookings();
    } catch (error) {
      onError(error as any);
    }
    setIsLoading(false);
  }, [onError, fetchBookings]);
  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChangeTage = async (tags: string[]) => {
    const nData = bookings.map((item) => {
      if (item.bookingId === dataCard?.bookingId)
        return { ...dataCard, summaryTags: tags };
      else return item;
    });
    setBookings(nData);
  };

  const handleSubmit = async () => {
    const nData = bookings.filter(
      (item) => item.bookingId !== dataCard?.bookingId
    );
    setDataCard(nData[0]);
    setBookings(nData);
  };

  return {
    width,
    isLoadingBookings,
    bookings,
    getPet,
    setDataCard,
    isLoading,
    dataCard,
    handleChangeTage,
    handleSubmit,
  };
}
